import React from 'react';
import Navigation from '../tulote/Navigation';
import Footer from '../tulote/Footer';
import { UserCircle, Search, MapPin, Phone, Home, CheckCircle } from 'lucide-react';
import brandConfig from '../../config/brandConfig';

const ComoFuncionaClientesPage = () => {
  const steps = [
    {
      icon: <Search className="w-8 h-8" />,
      title: '1. Explora proyectos',
      description: 'Navega por los proyectos inmobiliarios disponibles. Usa el mapa interactivo para ver la ubicacion y los lotes de cada proyecto.',
      color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
    },
    {
      icon: <MapPin className="w-8 h-8" />,
      title: '2. Encuentra tu lote',
      description: 'Haz clic en cualquier lote del mapa para ver su informacion: medidas, precio, estado y disponibilidad en tiempo real.',
      color: 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400',
    },
    {
      icon: <Phone className="w-8 h-8" />,
      title: '3. Contacta a la inmobiliaria',
      description: 'Comunicate directamente con la inmobiliaria por WhatsApp, telefono o correo. Resuelve tus dudas y agenda una visita.',
      color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
    },
    {
      icon: <Home className="w-8 h-8" />,
      title: '4. Visita y reserva',
      description: 'Visita el proyecto en persona, evalua las opciones y reserva el lote que mas te guste con el respaldo de la inmobiliaria.',
      color: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
    },
  ];

  const features = [
    'Mapa interactivo con lotes disponibles',
    'Informacion detallada de cada lote',
    'Contacto directo con la inmobiliaria',
    'Sin necesidad de crear cuenta',
    'Acceso desde cualquier dispositivo',
    'Precios y disponibilidad en tiempo real',
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navigation />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 mb-4">
            <UserCircle className="w-8 h-8 text-blue-600 dark:text-blue-400" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Para Clientes
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Explora proyectos inmobiliarios, encuentra tu lote ideal y contacta directamente a la inmobiliaria.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 hover:shadow-lg transition-shadow"
            >
              <div className={`inline-flex items-center justify-center w-14 h-14 rounded-lg ${step.color} mb-4`}>
                {step.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Features */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                Lo que puedes hacer
              </h2>
              <ul className="space-y-3">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-600 dark:text-gray-400">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-gradient-to-br from-blue-100 to-blue-200 dark:from-blue-900/40 dark:to-blue-800/40 rounded-xl p-8 text-center">
              <div className="text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">Gratis</div>
              <div className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-2">Sin registro necesario</div>
              <div className="text-blue-700 dark:text-blue-400 text-sm">
                Explora todos los proyectos sin crear una cuenta
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center bg-blue-50 dark:bg-blue-900/20 rounded-xl p-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
            Empieza a explorar proyectos
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Descubre los mejores proyectos inmobiliarios disponibles en tu zona.
          </p>
          <a
            href={brandConfig.projectDemoUrl}
            className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors"
          >
            <Search className="w-4 h-4 mr-2" />
            Ver Proyecto Demo
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ComoFuncionaClientesPage;
